<template>
  <div class="flex">
    <div class="text-sm">
      <p
        class="font-bold mt-0 mb-1"
        v-text="alertText"
      />
      <p
        class="mt-0"
        v-text="alertSecondary"
      />
    </div>
  </div>
</template>

<script type="text/babel">
export default {
  name: 'DeadlineRequirements',
  props: {
    currentDeadline: {
      type: [Boolean, String],
      required: true,
    },
    missingBankAccount: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    alertText() {
      return this.missingBankAccount
        ? 'Your account is missing a bank account!'
        : 'Your account is missing required information!'
    },
    alertSecondary() {
      return this.missingBankAccount
        ? `Please provide bank account information by ${this.currentDeadline} or your account may be disabled.`
        : `These requirements must be fulfilled by ${this.currentDeadline} or your account may be disabled.`
    },
  },
}
</script>
